var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseNewDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5159 29.167V37.6837L18.1992 33.3671L22.5159 29.167Z",
    fill: "#170F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1837 34.8835H22.4004V31.8501H45.1504V6.53345H29.7504V17.8501H26.7171V3.5H48.1837V34.8835Z",
    fill: "#170F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6662 26.25H36.6328V29.0502H39.6662V26.25Z",
    fill: "#170F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 51.9162H8.16602V14.8164H33.9493V29.1662H30.916V17.8496H11.1993V48.883H30.916V37.5664H33.9493V51.9162Z",
    fill: "#170F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6329 43.2832H19.5996V46.0831H22.6329V43.2832Z",
    fill: "#170F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseNewDevice);
export default __webpack_public_path__ + "static/media/choose-new-device.7fe7795d19311cd4e5899e9d2ff4648f.svg";
export { ForwardRef as ReactComponent };